import React, { Component } from 'react'
import './Features.scss'
import './ExploreOnlineClasses.scss'
import RoundCard from '../../Components/RoundCard'
import { Link } from 'react-router-dom'

export default class ExploreOnlineClasses extends Component {
    render() {
        return (
            <div className="explore-online-class-container">

                <h1>Explore Online Classes <img alt='features' src={require('../../Shared/icons/test.svg')}></img></h1>

                <div className="cards">
                    <Link to={'/online-class-list/6'}>
                        <RoundCard className='explore-online-class-card'>
                            <img alt='features' src={require('../../Shared/icons/6.svg')} />
                            <div className="title">Class 6<sup>th</sup> </div>
                        </RoundCard>
                    </Link>
                    <Link to={'/online-class-list/7'}>
                        <RoundCard className='explore-online-class-card'>
                            <img alt='features' src={require('../../Shared/icons/7.svg')} />
                            <div className="title">Class 7<sup>th</sup> </div>
                        </RoundCard>
                    </Link>
                    <Link to={'/online-class-list/8'}>
                        <RoundCard className='explore-online-class-card'>
                            <img alt='features' src={require('../../Shared/icons/8.svg')} />
                            <div className="title">Class 8<sup>th</sup> </div>
                        </RoundCard>
                    </Link>
                    <Link to={'/online-class-list/9'}>
                        <RoundCard className='explore-online-class-card'>
                            <img alt='features' src={require('../../Shared/icons/9.svg')} />
                            <div className="title">Class 9<sup>th</sup> </div>
                        </RoundCard>
                    </Link>
                    <Link to={'/online-class-list/10'}>
                        <RoundCard className='explore-online-class-card'>
                            <img alt='features' src={require('../../Shared/icons/10.svg')} />
                            <div className="title">Class 10<sup>th</sup> </div>
                        </RoundCard>
                    </Link>
                </div>

            </div>
        )
    }
}
